<ng-container>
  {{ currentError | translate }}
</ng-container>
